<template>
  <div class="d-flex align-items-center rounded-end rounded-5 container-warehouse-bot-text">
    <div>
      <img src="~/images/support.png" alt="Bot Mudango" width="70">
    </div>
    <div class="mx-3 text-center container-warehouse-bot-text">
      <span v-html="textbot" class="d-block fs-7 warehouse-bot-text"></span>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['textbot']
  }
</script>

<style scoped>
  .container-warehouse-bot-text {
    background: #f8f8f8;
  }

  .warehouse-bot-text {
    font-size: 0.8rem !important;
  }

  @media (max-width: 991px) {
    .warehouse-bot-text {
      font-size: 0.7rem !important;
    }
  }

</style>
